<template>
    <div class="pointer-events-none fixed inset-0 z-50">
        <component
            :is="backHref ? 'a' : 'button'"
            v-if="canBack || backHref"
            :href="backHref || undefined"
            :type="backHref ? undefined : 'button'"
            class="pointer-events-auto fixed left-3 top-3 flex items-center gap-x-1 p-1 text-white/80 hover:text-white lg:left-6 xxl:left-[10%]"
            @click="onBack"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 40.75 40.75"
                class="size-6 xl:size-8"
            >
                <g>
                    <polyline
                        points="24.44 29.92 14.89 20.38 24.44 10.83"
                        fill="none"
                        stroke="currentColor"
                        stroke-miterlimit="10"
                        stroke-width="2"
                    />
                    <circle
                        cx="20.38"
                        cy="20.38"
                        r="19.38"
                        fill="none"
                        stroke="currentColor"
                        stroke-miterlimit="10"
                        stroke-width="2"
                    />
                    <line
                        x1="14.89"
                        y1="20.38"
                        x2="39.94"
                        y2="20.38"
                        fill="none"
                        stroke="currentColor"
                        stroke-miterlimit="10"
                        stroke-width="2"
                    />
                </g>
            </svg>
        </component>
        <button
            v-if="canForward"
            class="pointer-events-auto fixed right-3 top-3 p-1 text-white/80 hover:text-white lg:right-6 xxl:right-[10%]"
            @click="$emit('forward')"
            type="button"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 40.75 40.75"
                class="size-6 rotate-180 lg:size-8"
            >
                <g>
                    <polyline
                        points="24.44 29.92 14.89 20.38 24.44 10.83"
                        fill="none"
                        stroke="currentColor"
                        stroke-miterlimit="10"
                        stroke-width="2"
                    />
                    <circle
                        cx="20.38"
                        cy="20.38"
                        r="19.38"
                        fill="none"
                        stroke="currentColor"
                        stroke-miterlimit="10"
                        stroke-width="2"
                    />
                    <line
                        x1="14.89"
                        y1="20.38"
                        x2="39.94"
                        y2="20.38"
                        fill="none"
                        stroke="currentColor"
                        stroke-miterlimit="10"
                        stroke-width="2"
                    />
                </g>
            </svg>
        </button>
    </div>
</template>
<script setup lang="ts">
const props = defineProps<{
    canBack: boolean;
    canForward: boolean;
    /** When set, the back control renders as a plain link to this URL. */
    backHref?: string | null;
}>();

const emit = defineEmits<{ (e: "back"): void; (e: "forward"): void }>();

function onBack(e: MouseEvent) {
    if (!props.backHref) {
        emit("back");
        return;
    }

    // Let modified clicks (new tab, etc.) behave like a normal link.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) {
        return;
    }

    // The target differs from the current URL only by its hash, so the
    // browser would treat it as a same-document navigation and leave the
    // quiz mounted. Force a full load so the underlying page is shown.
    e.preventDefault();
    window.location.assign(props.backHref);
    window.location.reload();
}
</script>
